import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';
import { NODE_ENV } from '@/config';

import appModule, { name as appModuleName } from '@/store/modules/app';
import commonModule, {
  name as commonModuleName,
} from '@/store//modules/common';
import userModule, { name as userModuleName } from '@/store/modules/user';

import studentModule, {
  name as studentModuleName,
} from '@/store/modules/student';

Vue.use(Vuex);

const debug = NODE_ENV !== 'production';

//Only Modules is always loaded with the app
export const modulesName = {
  appModuleName: appModuleName,
  commonModuleName: commonModuleName,
  userModuleName: userModuleName,
  studentModule: studentModule,
};

export default new Vuex.Store({
  strict: debug,
  modules: {
    [appModuleName]: appModule,
    [commonModuleName]: commonModule,
    [userModuleName]: userModule,
    [studentModuleName]: studentModule,
  },
  plugins: debug ? [createLogger()] : [],
});
